import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import classnames from 'classnames';
import NotificationBadge from './NotificationBadge';
import { PORTAL_SERVICOS_BACKEND } from 'commons/constants/environment';
import { hasIndentificationUser } from 'commons/util/sanitizerUser';

import { ROUTES } from 'commons/routes/routes';
import { H6Styled, HeaderStyled } from './styled';

class AppToolbar extends PureComponent {
	renderMenuButton() {
		const { open } = this.props;

		return (
			<div
				role="menuitem"
				className={classnames('sds-topbar__menu-btn', {
					'sds-topbar__menu-btn--active': open
				})}
				aria-label="Expandir o texto do menu"
				onClick={this.props.menuToggle}>
				<img className="imgIconMenu"
					src={`${process.env.PUBLIC_URL}/assets/sds/assets/menu-icon.svg`}
					alt="Icone de menu"
				/>
			</div>
		);
	}

	render() {
		const { isAuthenticated } = this.props;
		const user = hasIndentificationUser();

		return (
			<HeaderStyled
				className={classnames('sds-topbar', {
					'sds-topbar--center': !isAuthenticated
				})}>
				{this.renderMenuButton()}
				<Link to={ROUTES.ONBOARDING.path} className="sds-topbar__logo">
					<img className='logo_cliente'
						src={`${PORTAL_SERVICOS_BACKEND}/configuracoes/frontend/download/logo.cliente`}
						alt="Logo"
					/>
				</Link>
				<div >
					<H6Styled className="sds-hide-xs">
						<FormattedMessage id="LABELS.COMMONS.CLIENTE.NOME" />
					</H6Styled>
					<H6Styled className="sds-hide-xs">
						<FormattedMessage id="LABELS.COMMONS.PORTAL.HEADER" />
					</H6Styled>
				</div>
				{user && <NotificationBadge />}
			</HeaderStyled>
		);
	}
}

AppToolbar.propTypes = {
	open: PropTypes.bool.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
	menuToggle: PropTypes.func.isRequired
};

export default compose(injectIntl)(AppToolbar);
